<template>
  <div class="points-rule-management">
    <!-- 搜索区域 -->
    <a-card title="积分规则查询" :bordered="false" class="search-card">
      <a-form layout="inline" :form="searchForm">
        <a-row :gutter="16">
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="规则名称">
              <a-input
                  v-decorator="['ruleName']"
                  placeholder="请输入规则名称"
                  allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="规则类型">
              <a-select
                  v-decorator="['ruleType']"
                  placeholder="请选择规则类型"
                  allow-clear
                  class="wide-select"
              >
                <a-select-option :value="1">充值返利</a-select-option>
                <a-select-option :value="2">消费返利</a-select-option>
                <a-select-option :value="3">注册赠送</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24">
            <a-form-item label="规则状态">
              <a-select
                  v-decorator="['status']"
                  placeholder="请选择状态"
                  allow-clear
                  class="wide-select"
              >
                <a-select-option :value="1">启用</a-select-option>
                <a-select-option :value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="8" :md="12" :sm="24" class="search-actions">
            <a-space>
              <a-button type="primary" @click="handleSearch">查询</a-button>
              <a-button @click="handleReset">重置</a-button>
              <a-button type="primary" @click="showCreateModal">新增规则</a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-form>
    </a-card>

    <!-- 表格区域 -->
    <a-card title="积分规则列表" :bordered="false" class="table-card">
      <a-table
          :columns="columns"
          :dataSource="tableData"
          :pagination="pagination"
          :loading="loading"
          rowKey="id"
          bordered
          :scroll="{ x: 1500, y: 600 }"
          @change="handleTableChange"
      >
        <template slot="ruleType" slot-scope="text">
          <a-tag :color="text === 1 ? 'blue' : text === 2 ? 'green' : 'red'">
            {{ getRuleTypeText(text) }}
          </a-tag>
        </template>

        <template slot="status" slot-scope="text">
          <a-tag :color="text === 1 ? 'green' : 'red'">
            {{ getStatusText(text) }}
          </a-tag>
        </template>

        <template slot="time" slot-scope="text, record">
          <div>{{ formatTime(record.startTime) }} ~ {{ record.endTime ? formatTime(record.endTime) : '长期有效' }}</div>
        </template>

        <template slot="rebateRatio" slot-scope="text">
          {{ getRebateRatioText(text) }}%
        </template>

        <template slot="action" slot-scope="text, record">
          <a-space>
            <a @click="handleEdit(record)">编辑</a>
            <a @click="handleDelete(record.id)">删除</a>
            <a @click="handleStatusChange(record.id, record.status !== 1)">
              {{ record.status === 1 ? '禁用' : '启用' }}
            </a>
            <a type="link" size="small" @click="handleRecord(record)">记录</a>
            <a type="link" size="small" @click="handleManualGrant(record)">手动发放</a>
          </a-space>
        </template>
      </a-table>
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal
        :visible="modalVisible"
        :title="modalTitle"
        width="800px"
        centered
        @ok="handleSubmit"
        @cancel="handleCancel"
    >
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="规则名称">
          <a-input
              v-decorator="['ruleName', { rules: [{ required: true, message: '请输入规则名称' }] }]"
              placeholder="请输入规则名称"
          />
        </a-form-item>

        <a-form-item label="规则类型">
          <a-radio-group
              v-decorator="['ruleType', { initialValue: 1, rules: [{ required: true, message: '请选择规则类型' }] }]"
              @change="handleRuleTypeChange"
          >
            <a-radio :value="1">充值返利</a-radio>
            <a-radio :value="2">消费返利</a-radio>
            <a-radio :value="3">注册积分</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="生效时间">
          <a-date-picker
              v-decorator="['startTime', { rules: [{ required: true, message: '请选择生效时间' }] }]"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              style="width: 100%"
          />
        </a-form-item>

        <a-form-item label="结束时间">
          <a-date-picker
              v-decorator="['endTime']"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              style="width: 100%"
              :disabled-date="disabledEndDate"
          />
        </a-form-item>

        <!-- 动态显示返利比例或固定积分 -->
        <a-form-item
            v-if="form.getFieldValue('ruleType') !== 3"
            label="返利比例"
            key="rebateRatio"
        >
          <div style="display: flex; align-items: center; width: 16%">
            <a-input-number
                v-decorator="['rebateRatio', {
            rules: [
              { required: form.getFieldValue('ruleType') !== 3, message: '请输入返利比例' },
              { type: 'number', min: 0.1, message: '返利比例最小为0.1%' }
            ]
          }]"
                :min="0.1"
                :precision="1"
                style="flex: 1; margin-right: 8px;"
            />
            <span>%</span>
          </div>
        </a-form-item>

        <a-form-item
            v-if="form.getFieldValue('ruleType') === 3"
            label="固定积分"
            key="fixedPointsItem"
        >
          <a-input-number
              v-decorator="['fixedPoints', {
            rules: [
              { required: true, message: '请输入固定积分' },
              { type: 'number', min: 1, message: '积分必须大于0' }
            ]
          }]"
              :min="1"
              :precision="0"
          />
        </a-form-item>

        <a-form-item label="规则状态">
          <a-switch
              v-decorator="['status', { valuePropName: 'checked', initialValue: true }]"
              checked-children="启用"
              un-checked-children="禁用"
          />
        </a-form-item>

        <a-form-item label="规则描述">
          <a-textarea
              v-decorator="['description']"
              placeholder="请输入规则描述"
              :rows="4"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 积分规则详情 -->
    <points-record-detail
        ref="pointsRecordModal"
        :visible="recordModalVisible"
        @cancel="recordModalVisible = false"
    />
    <!-- 在template适当位置添加 -->
    <manual-grant-points
        :visible="manualGrantVisible"
        :rule-id="currentRuleId"
        @cancel="manualGrantVisible = false"
    />
  </div>
</template>

<script>
import {message, Modal} from 'ant-design-vue';
import PointsRecordDetail from './modules/PointsRecordDetail.vue';
import ManualGrantPoints from './modules/ManualGrantPoints.vue';
import dayjs from 'dayjs';
import {
  getPointsRules,
  createPointsRule,
  updatePointsRule,
  deletePointsRule,
  changeRuleStatus
} from 'api/points';

export default {
  components: {
    PointsRecordDetail,
    ManualGrantPoints
  },
  data() {
    return {
      // 搜索表单
      searchForm: this.$form.createForm(this),
      recordModalVisible: false,
      currentRecordId: null,
      manualGrantVisible: false,
      currentRuleId: null,
      // 表格数据
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50']
      },

      // 表格列配置
      columns: [
        {
          title: '规则名称',
          dataIndex: 'ruleName',
          key: 'ruleName',
          align: 'center',
          width: 300,
          ellipsis: true
        },
        {
          title: '规则类型',
          dataIndex: 'ruleType',
          key: 'ruleType',
          align: 'center',
          scopedSlots: {customRender: 'ruleType'}
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '生效时间段',
          key: 'time',
          align: 'center',
          width: 300,
          scopedSlots: {customRender: 'time'}
        },
        {
          title: '规则有效期',
          dataIndex: 'validDays',
          key: 'validDays',
          align: 'center',
          customRender: text => `${text}天`
        },
        {
          title: '返利比例',
          dataIndex: 'rebateRatio',
          key: 'rebateRatio',
          align: 'center',
          scopedSlots: {customRender: 'rebateRatio'},
        },
        {
          title: '固定积分',
          dataIndex: 'fixedPoints',
          key: 'fixedPoints',
          align: 'center',
          scopedSlots: {customRender: 'fixedPoints'},
          customRender: (text) => text !== undefined && text !== null ? text : '-',
          sorter: (a, b) => a.fixedPoints - b.fixedPoints
        },
        {
          title: '操作',
          key: 'action',
          width: 260,
          fixed: 'right',
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],

      // 弹窗相关
      modalVisible: false,
      modalTitle: '新增积分规则',
      form: this.$form.createForm(this),
      currentRecord: null
    };
  },

  mounted() {
    this.loadData();
    this.$watch(
        () => this.form.getFieldValue('ruleType'),
        (newType) => {
          if (this.currentRecord && this.modalVisible) {
            this.$nextTick(() => {
              if (newType === 3) {
                this.form.setFieldsValue({
                  fixedPoints: this.currentRecord.fixedPoints
                })
              }
            })
          }
        },
        { immediate: true }
    )
  },

  methods: {
    // 点击手动发放按钮
    handleManualGrant(record) {
      this.currentRuleId = record.id;
      this.manualGrantVisible = true;
    },
    // 辅助函数：获取规则类型文本
    getRuleTypeText(type) {
      const map = {
        1: '充值返利',
        2: '消费返利',
        3: '注册赠送'
      };
      return map[type] || '未知类型';
    },

    // 规则类型切换时重置相关字段
    handleRuleTypeChange(e) {
      const ruleType = e.target.value;
      if (ruleType === 3) {
        this.form.setFieldsValue({rebateRatio: undefined}); // 清空返利比例
      } else {
        this.form.setFieldsValue({fixedPoints: undefined}); // 清空固定积分
      }
    },

    // 辅助函数：获取状态文本
    getStatusText(status) {
      return status === 1 ? '已启用' : '已禁用';
    },

    // 辅助函数：返利比例格式化
    getRebateRatioText(rebateRatio) {
      return (rebateRatio * 100).toFixed(0)
    },

    // 辅助函数：格式化时间
    formatTime(time) {
      return dayjs(time).format('YYYY年MM月DD日');
    },

    // 加载数据
    async loadData() {
      try {
        this.loading = true;
        const values = this.searchForm.getFieldsValue();
        const params = {
          ...values,
          current: this.pagination.current,
          size: this.pagination.pageSize
        };
        const res = await getPointsRules(params);
        this.tableData = res.data.records || [];
        this.pagination.total = res.data.total || 0;
      } catch (error) {
        console.error('加载数据失败:', error);
        message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },

    // 重置
    handleReset() {
      this.searchForm.resetFields();
      this.handleSearch();
    },

    // 分页变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },
    handleRecord(record) {
      this.currentRecordId = record.id;
      this.recordModalVisible = true;
      this.$nextTick(() => {
        this.$refs.pointsRecordModal.setRuleId(record.id);
      });
    },
    // 状态切换
    async handleStatusChange(id, checked) {
      try {
        // 显示确认对话框
        const that = this;
        const params = {
          id: id,
          status: checked ? 1 : 0
        };
        this.$confirm({
          title: '确认操作',
          content: `确认要${checked ? '启用' : '禁用'}该积分规则吗？`,
          onOk() {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
              try {
                await changeRuleStatus(params);
                message.success('状态更新成功');
                that.loadData();
                resolve();
              } catch (error) {
                console.error('状态更新失败:', error);
                message.error('状态更新失败');
                reject();
              }
            });
          },
          onCancel() {
            console.log('取消操作');
          },
        });
      } catch (error) {
        console.error('操作失败:', error);
      }
    },

    // 显示新增弹窗
    showCreateModal() {
      this.modalTitle = '新增积分规则';
      this.currentRecord = null;
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 显示编辑弹窗
    async handleEdit(record) {
      this.modalTitle = '编辑积分规则';
      this.currentRecord = record;
      this.modalVisible = true;
      console.log("this.currentRecord===", this.currentRecord);

      this.form.resetFields()
      // 准备基础数据
      const baseData = {
        ruleName: record.ruleName,
        status: record.status === 1,
        ruleType: record.ruleType,
        startTime: dayjs(record.startTime),
        endTime: record.endTime ? dayjs(record.endTime) : undefined,
        description: record.description || ''
      }

      // 等待模态框完全渲染
      await this.$nextTick()
      this.form.setFieldsValue(baseData)
      // 特殊处理动态字段
      if (record.ruleType === 3) {
        await this.$nextTick()
        this.form.setFieldsValue({
          fixedPoints: record.fixedPoints
        })
      } else {
        await this.$nextTick()
        this.form.setFieldsValue({
          rebateRatio: record.rebateRatio ? (record.rebateRatio * 100) : 0
        })
      }
    },

    // 删除规则
    async handleDelete(id) {
      Modal.confirm({
        title: '确认删除',
        content: '确认要删除该积分规则吗？删除后不可恢复',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          // eslint-disable-next-line no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            try {
              await deletePointsRule({id: id});
              message.success('删除成功');
              this.loadData();
              resolve();
            } catch (error) {
              console.error('删除失败:', error);
              message.error('删除失败');
              reject();
            }
          });
        },
        onCancel() {
          console.log('取消删除');
        },
      });
    },

    // 提交表单
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (err) {
          console.error('表单验证错误:', err);
          return;
        }

        try {
          // 根据规则类型处理不同字段
          const processedValues = {
            ...values,
            id: this.currentRecord ? this.currentRecord.id : undefined,
            status: values.status ? 1 : 0,
            startTime: values.startTime ? values.startTime.format('YYYY-MM-DD HH:mm:ss') : null,
            endTime: values.endTime ? values.endTime.format('YYYY-MM-DD HH:mm:ss') : null
          };

          // 处理返利比例和固定积分
          if (values.ruleType === 3) {
            // 注册积分规则 - 删除返利比例字段
            delete processedValues.rebateRatio;
          } else {
            // 其他规则 - 删除固定积分字段并将百分比转换为小数
            delete processedValues.fixedPoints;
            if (values.rebateRatio !== undefined) {
              processedValues.rebateRatio = Number(values.rebateRatio) / 100;
            }
          }

          console.log('提交数据:', processedValues);

          if (this.currentRecord) {
            await updatePointsRule(processedValues);
            message.success('更新成功');
          } else {
            await createPointsRule(processedValues);
            message.success('创建成功');
          }

          this.modalVisible = false;
          this.loadData();
        } catch (error) {
          console.error('提交失败:', error);
          message.error('提交失败');
        }
      });
    },

    // 取消表单
    handleCancel() {
      this.form.resetFields();
      this.modalVisible = false;
    },

    // 禁用结束日期（早于开始日期）
    disabledEndDate(current) {
      const startTime = this.form.getFieldValue('startTime');
      if (!startTime) return false;
      return current && current < startTime.endOf('day');
    }
  }
};
</script>

<style lang="less" scoped>
.points-rule-management {
  padding: 16px;
  background: #f5f7fa;

  .search-card {
    margin-bottom: 16px;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    /deep/ .ant-card-body {
      padding-bottom: 0;
    }

    .search-actions {
      text-align: right;
    }
  }

  .table-card {
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    /deep/ .ant-table-thead > tr > th {
      background-color: #fafafa;
    }
  }
}

@media (max-width: 768px) {
  .points-rule-management {
    padding: 8px;

    .search-card {
      /deep/ .ant-form-item {
        margin-bottom: 16px;
      }

      .search-actions {
        text-align: left;
      }
    }
  }
}

.wide-select {
  min-width: 160px !important;
}
</style>
